import { render, staticRenderFns } from "./rgApplynoticesAction.vue?vue&type=template&id=572e6a0e&scoped=true"
import script from "./rgApplynoticesAction.vue?vue&type=script&lang=js"
export * from "./rgApplynoticesAction.vue?vue&type=script&lang=js"
import style0 from "./rgApplynoticesAction.vue?vue&type=style&index=0&id=572e6a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e6a0e",
  null
  
)

export default component.exports